import { render, staticRenderFns } from "./stander-modal-table-list.vue?vue&type=template&id=687d373b&scoped=true&"
import script from "./stander-modal-table-list.vue?vue&type=script&lang=ts&"
export * from "./stander-modal-table-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d373b",
  null
  
)

export default component.exports